export const gitCommit = '4a6ca3e1'
